import _toConsumableArray from "/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import logger from '../../logger';
import { dataTypeOf } from './dataType';
var types = {};
var dataTypes = {};
var unregExts = {};

var parseNativeTypes = function parseNativeTypes(input, dataType) {
  switch (dataType) {
    case 'Array':
      if (input.length === 0 || input.every(function (entry) {
        return type(entry) === '@csl/object';
      })) {
        return '@csl/list+object';
      } else {
        return '@else/list+object';
      }

    case 'SimpleObject':
    case 'ComplexObject':
      return '@csl/object';

    default:
      return '@invalid';
  }
};

var matchType = function matchType() {
  var typeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data = arguments.length > 1 ? arguments[1] : undefined;

  var _iterator = _createForOfIteratorHelper(typeList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _type = _step.value;

      if (types[_type].predicate(data)) {
        return matchType(types[_type].extensions, data) || _type;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

export var type = function type(input) {
  var dataType = dataTypeOf(input);

  if (dataType === 'Array' && input.length === 0) {
    return parseNativeTypes(input, dataType);
  }

  var match = matchType(dataTypes[dataType], input);
  return match || parseNativeTypes(input, dataType);
};
export var addTypeParser = function addTypeParser(format, _ref) {
  var dataType = _ref.dataType,
      predicate = _ref.predicate,
      extend = _ref.extends;
  var extensions = [];

  if (format in unregExts) {
    extensions = unregExts[format];
    delete unregExts[format];
    logger.debug('[core]', "Subclasses \"".concat(extensions, "\" finally registered to parent type \"").concat(format, "\""));
  }

  var object = {
    predicate: predicate,
    extensions: extensions
  };
  types[format] = object;

  if (extend) {
    var parentTypeParser = types[extend];

    if (parentTypeParser) {
      parentTypeParser.extensions.push(format);
    } else {
      if (!unregExts[extend]) {
        unregExts[extend] = [];
      }

      unregExts[extend].push(format);
      logger.debug('[core]', "Subclass \"".concat(format, "\" is waiting on parent type \"").concat(extend, "\""));
    }
  } else {
    var typeList = dataTypes[dataType] || (dataTypes[dataType] = []);
    typeList.push(format);
  }
};
export var hasTypeParser = function hasTypeParser(type) {
  return Object.prototype.hasOwnProperty.call(types, type);
};
export var removeTypeParser = function removeTypeParser(type) {
  delete types[type];
  var typeLists = [].concat(_toConsumableArray(Object.keys(dataTypes).map(function (key) {
    return dataTypes[key];
  })), _toConsumableArray(Object.keys(types).map(function (type) {
    return types[type].extensions;
  }).filter(function (list) {
    return list.length > 0;
  })));
  typeLists.forEach(function (typeList) {
    var index = typeList.indexOf(type);

    if (index > -1) {
      typeList.splice(index, 1);
    }
  });
};
export var listTypeParser = function listTypeParser() {
  return Object.keys(types);
};
export var treeTypeParser = function treeTypeParser() {
  var attachNode = function attachNode(name) {
    return {
      name: name,
      children: types[name].extensions.map(attachNode)
    };
  };

  return {
    name: 'Type tree',
    children: Object.keys(dataTypes).map(function (name) {
      return {
        name: name,
        children: dataTypes[name].map(attachNode)
      };
    })
  };
};
export var typeMatcher = /^(?:@(.+?))(?:\/(?:(.+?)\+)?(?:(.+)))?$/;